module.exports = __webpack_public_path__ + "img/group_remove_opsz20B.9f687fd7.svg";